import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-FM-logo_svg__katman_1",
  "data-name": "katman 1",
  viewBox: "0 0 144 98.6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-FM-logo_svg__cls-2{fill:#fff}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M0 98.6s15.4-1.9 36.5-22.4L105.6 0H144l-32 97.9-112 .7Z",
      style: {"fill":"#de0038"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M48.3 72.8s.5-.6 1-.6.9.6.9.6h-1.9Zm70.9-38.4c.5 0-14.2-.7-18.9.2s-9.2 1.5-13.5 7.8c-4.3 6.2-8.3 12.5-10.9 16.1-8.2 11.3-8.2 13.1-17.2 13.9-4.9.4-6.1.2-7.4-.4-1.5-.7-2.2-1.5-4.3.1-2.4 1.9-5.7 1.4-5.6 1.7h69.1s3.4.1 4.5-2l-1.7-.6s-.4 2.2-7.2 1.5c-6.9-.6-15.8-2.3-15.8-2.3l21.3-30c1.3-1.6 3.1-3.4 4.9-4.9 0 0-8.6.9-12.2 6.1-3.7 5.3-20 27.7-20 27.7l-1.1-.2L104 40.2c.1 0 3.1-4.9 15.2-5.8",
      class: "svg-FM-logo_svg__cls-2"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M49.2 69.3c-1.2 0-2.2 1.6-2.2 1.6h4.5s-1.1-1.6-2.3-1.6",
      class: "svg-FM-logo_svg__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "FM-logo"}) } }